import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { LoginService } from '../../services/login/login.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  spinner = false;
  passwordForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private alertController: AlertController
  ) {}

  ngOnInit() {
    this.passwordForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
          ),
        ],
      ],
    });
  }

  sendPasswordResetLink() {
    this.spinner = true;
    const email = this.passwordForm.value.email;
    this.loginService
      .resetPassword(email)
      .then((response) => {
        this.spinner = false;
        this.presentAlert('Re-set link sent, check your email');
      })
      .catch(() => {
        this.presentAlert('Could not send link');
      });
    this.spinner = false;
  }

  async presentAlert(msg) {
    const alert = await this.alertController.create({
      message: msg,
      buttons: ['OK'],
    });

    await alert.present();
  }
}
